
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { FlagsPermissionCbp } from "@/feature-flags/flags-cbp";
import { Vue, Options } from "vue-class-component";

@Options({
  watch: {
    "$route.fullPath": {
      handler() {
        this.getActiveTabRect();
      },
      immediate: true
    },
    loading: {
      handler() {
        this.getActiveTabRect();
      },
      immediate: true
    }
  }
})
export default class BookingList extends Vue {
  get tabs() {
    return [
      {
        name: this.$t("bookingShipment.list.tabBookingList"),
        path: "/booking-v2/booking-list",
        refName: "bookingList",
        permission: true
      },
      {
        name: this.$t("bookingCbp.tabTitle"),
        path: "/booking-v2/booking-client-cbp-list",
        refName: "bookingListCBP",
        permission: FlagsPermissionCbp.cbp_enable_v2.isEnabled()
      }
    ];
  }

  tabRect = new DOMRect();
  resizeObserver: any = null;

  get loading() {
    return MainAppController.loadingModal;
  }

  async mounted() {
    await this.$nextTick();
    this.getActiveTabRect();
    const containerElement = document.getElementById(
      "booking-v2-tab-container"
    );
    if (!containerElement) return;
    this.resizeObserver = new (window as any).ResizeObserver(() => {
      this.getActiveTabRect();
    });
    this.resizeObserver.observe(containerElement);
  }

  unmounted() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  async getActiveTabRect() {
    await this.$nextTick();
    const $tabElementRef = this.$refs[
      this.tabs.find((tab) => tab.path === this.$route.fullPath)
        ?.refName as keyof BookingList
    ] as any;
    if (!$tabElementRef) return new DOMRect();
    const $tabElement = $tabElementRef.$el as HTMLElement;
    this.tabRect = $tabElement.getBoundingClientRect();
  }
}
